import { MessageSquare, Lightbulb, Pencil, Trash2, Bug } from "lucide-react";

export const FEEDBACK_USER_ID_KEY = "feedback-user-id";
export const FEEDBACK_USER_EMAIL_KEY = "feedback-user-email";
export const FEEDBACK_USER_NAME_KEY = "feedback-user-name";
/**
 * Set when the user has explicitly confirmed their submitter identity in the
 * identity step. Without this flag the identity screen is always shown (even
 * for authenticated users) so that multiple people sharing one login can each
 * identify themselves individually.
 */
export const FEEDBACK_SUBMITTER_CONFIRMED_KEY = "feedback-submitter-confirmed";

export const MAX_FEEDBACK_LENGTH = 10_000;
export const MAX_SCREENSHOT_BYTES = 5 * 1024 * 1024; // 5MB
export const MAX_CHAT_MESSAGES = 50;

export const categoryConfig: Record<
  string,
  { label: string; icon: typeof MessageSquare; color: string; bgColor: string }
> = {
  "Feature Request": {
    label: "Feature Request",
    icon: Lightbulb,
    color: "text-blue-600",
    bgColor: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400",
  },
  "Change Request": {
    label: "Change Request",
    icon: Pencil,
    color: "text-amber-600",
    bgColor:
      "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400",
  },
  "Removal Request": {
    label: "Removal Request",
    icon: Trash2,
    color: "text-red-600",
    bgColor: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400",
  },
  "Bug Report": {
    label: "Bug Report",
    icon: Bug,
    color: "text-orange-600",
    bgColor:
      "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400",
  },
  General: {
    label: "General",
    icon: MessageSquare,
    color: "text-gray-600",
    bgColor: "bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-400",
  },
};

export const statusConfig: Record<string, { label: string; color: string }> = {
  Open: {
    label: "Open",
    color:
      "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400",
  },
  "In Progress": {
    label: "In Progress",
    color: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400",
  },
  Resolved: {
    label: "Resolved",
    color:
      "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400",
  },
  Closed: {
    label: "Closed",
    color: "bg-gray-100 text-gray-600 dark:bg-gray-900/30 dark:text-gray-400",
  },
  "Wont Fix": {
    label: "Won't Fix",
    color:
      "bg-slate-100 text-slate-600 dark:bg-slate-900/30 dark:text-slate-400",
  },
};

export const priorityConfig: Record<string, { label: string; color: string }> =
  {
    Low: {
      label: "Low",
      color:
        "bg-slate-100 text-slate-700 dark:bg-slate-900/30 dark:text-slate-400",
    },
    Medium: {
      label: "Medium",
      color:
        "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400",
    },
    High: {
      label: "High",
      color: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400",
    },
  };

export const statusOptions = [
  { value: "Open", label: "Open" },
  { value: "In Progress", label: "In Progress" },
  { value: "Resolved", label: "Resolved" },
  { value: "Closed", label: "Closed" },
  { value: "Wont Fix", label: "Won't Fix" },
];

export const categoryLabels: Record<string, string> = Object.fromEntries(
  Object.entries(categoryConfig).map(([k, v]) => [k, v.label]),
);
